/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.31",
    versionName: "0.2.0-nightly.2026.3.31",
    versionChannel: "nightly",
    buildDate: "2026-03-31T00:15:27.429Z",
    commitHash: "8238f7cf5b747b8f23c3aca86b5f5eaae1b0e692",
};
